import { useSelector } from "react-redux";
import { RootState } from "../../store/index";
import { Navigate } from "react-router";

interface ProtectedRoutesProps {
  route: string;
  children: React.ReactNode;
  replace: boolean;
}

export default function ProtectedRoutes({
  route,
  children,
  replace
}: ProtectedRoutesProps) {
  const token = useSelector((state: RootState) => state.auth.token);
  // console.log(token);

  if (!token) {
    return <Navigate to={route} replace={replace} />;
  }

  return <>{children}</>;
}
